import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import ServicesPage from './Pages/ServicesPage';
import ContactPage from './Pages/ContactPage';
import Navbar from './Components/Navbar';
import Sidebar from './Components/Sidebar';
import GlobaleStyle from './globaleStyles'
import Footer from './Components/Footer'

function App() {
  const [isOpen, setisOpen] = useState(false)

  const toggle = () => {
    setisOpen(!isOpen);
  }

  return (
    <Router>
      <GlobaleStyle />
      <Sidebar toggle={toggle} isOpen={isOpen} />
      <Navbar toggle={toggle} />

      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/services' element={<ServicesPage />} />
        <Route path='/contact' element={<ContactPage />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;